import { cardsValuesConvertNumber } from '../enums/cardsValuesConvertNumber';

function convertCardValues(card) {
  const value = card.split('_')[1];

  return cardsValuesConvertNumber[value];
}

function compareValues(first, second) {
  if (first > second) return 'high';

  if (first < second) return 'low';

  return 'equal';
}

export function compareCardValues(firstCard, secondCard) {
  const first = convertCardValues(firstCard.card);
  const second = convertCardValues(secondCard.card);

  return compareValues(first, second);
}
